import { Channel } from "@swivl-mono/types";
import { ButtonColor } from "@swivl-mono/ui";
import { IconType } from "react-icons";
import { FaMobileAlt } from "react-icons/fa";
import { IoIosCall } from "react-icons/io";
import { LuMessageSquareText } from "react-icons/lu";

const paramToChannelMap: Record<string, Channel> = {
  web: Channel.WEB,
  sms: Channel.SMS,
  voice: Channel.VOICE,
  gMB: Channel.GOOGLE_MY_BUSINESS,
  fBM: Channel.FACEBOOK_MESSENGER,
  whatsApp: Channel.WHATSAPP
};
export interface ChannelColor {
  accent: string;
  bg: string;
  border: string;
  hover: string;
  main: string;
  text: string;
  caret: string;
  buttonColor?: ButtonColor;
}
export interface ChannelColors extends Record<Channel, ChannelColor> {}

export const ChannelColors: ChannelColors = {
  [Channel.WEB]: {
    accent: "#ff7f3a",
    bg: "bg-orange-500",
    border: "hover:border-orange-500 focus-visible:border-orange-500 hover:outline-orange-500 focus-visible:outline-orange-500",
    hover: "hover:text-orange-500",
    main: "#ff5b02",
    text: "text-orange-500",
    caret: "caret-orange-500",
    buttonColor: ButtonColor.ORANGE
  },
  [Channel.SMS]: {
    accent: "#00aaa2",
    bg: "bg-teal-500",
    border: "hover:border-teal-500 focus-visible:border-teal-500 hover:outline-teal-500 focus-visible:outline-teal-500",
    hover: "hover:text-teal-500",
    main: "#01cbc0",
    text: "text-teal-500",
    caret: "caret-teal-500",
    buttonColor: ButtonColor.TEAL
  },
  [Channel.VOICE]: {
    accent: "#ffb801",
    bg: "bg-yellow-700",
    border: "hover:border-yellow-700 focus-visible:border-yellow-700 hover:outline-yellow-700 focus-visible:outline-yellow-700",
    hover: "hover:text-yellow-700",
    main: "#ffa904",
    text: "text-yellow-700",
    caret: "caret-yellow-700",
    buttonColor: ButtonColor.YELLOW
  },
  [Channel.GOOGLE_MY_BUSINESS]: {
    accent: "",
    bg: "",
    border: "",
    hover: "",
    main: "",
    text: "",
    caret: "",
    buttonColor: ButtonColor.ORANGE
  },
  [Channel.FACEBOOK_MESSENGER]: {
    accent: "#ffb801",
    bg: "bg-yellow-700",
    border: "hover:border-yellow-700 focus-visible:border-yellow-700 hover:outline-yellow-700 focus-visible:outline-yellow-700  ",
    hover: "hover:text-yellow-700",
    text: "text-yellow-700",
    main: "#ffa904",
    caret: "caret-yellow-700",
    buttonColor: ButtonColor.ORANGE
  },
  [Channel.WHATSAPP]: {
    accent: "#ffb801",
    bg: "bg-yellow-700",
    border: "hover:border-yellow-700 focus-visible:border-yellow-700 hover:outline-yellow-700 focus-visible:outline-yellow-700",
    hover: "hover:text-yellow-700",
    main: "#ffa904",
    text: "text-yellow-700",
    caret: "caret-yellow-700",
    buttonColor: ButtonColor.ORANGE
  }
};

export const ChannelIcons: Record<Channel, IconType> = {
  [Channel.WEB]: LuMessageSquareText,
  [Channel.SMS]: FaMobileAlt,
  [Channel.VOICE]: IoIosCall,
  [Channel.GOOGLE_MY_BUSINESS]: LuMessageSquareText,
  [Channel.FACEBOOK_MESSENGER]: LuMessageSquareText,
  [Channel.WHATSAPP]: LuMessageSquareText
};

export enum SupportingButtonColors {
  WHITE = "white",
  YELLOW = "yellow",
  BLACK = "black",
  DARK_GREY = "darkGrey",
  RED = "red"
}

export const supportButtonStyles: Record<SupportingButtonColors, { main: string; accent: string }> = {
  [SupportingButtonColors.WHITE]: {
    main: "#ffffff",
    accent: "#f5f5f5"
  },
  [SupportingButtonColors.YELLOW]: {
    main: "#ffd41e",
    accent: "#ffb801"
  },
  [SupportingButtonColors.BLACK]: {
    main: "#323232",
    accent: "#1b1b1b"
  },
  [SupportingButtonColors.DARK_GREY]: {
    main: "#707070",
    accent: "#4b4b4b"
  },
  [SupportingButtonColors.RED]: {
    main: "#ff4b34",
    accent: "#e71b00"
  }
};

export function GetChannelFromParam(param?: string): Channel {
  return paramToChannelMap[param?.toLowerCase() ?? ""] ?? Channel.WEB;
}
